import { ApplicationState } from '~/store/store';

export const getProjectState = (state: ApplicationState) => state.project;
